export const FETCH_OFFICES = "FETCH_OFFICES";
export const SELECT_OFFICE = "SELECT_OFFICE";
export const GETTING_OFFICES = "GETTING_OFFICES";
export const GETTING_ASSIGNMENT_MANAGER_LIST = "GETTING_ASSIGNMENT_MANAGER_LIST";
export const SET_ASSIGNMENT_MANAGER_LIST = "SET_ASSIGNMENT_MANAGER_LIST";
export const GETTING_COMMITMENTS = "GETTING_COMMITMENTS";
export const ASSIGNMENT_MANAGER_GET_COMMITMENTS = "ASSIGNMENT_MANAGER_GET_COMMITMENTS";
export const ASSIGNMENT_MANAGER_SELECTED = "ASSIGNMENT_MANAGER_SELECTED";
export const SELECT_ASSIGNMENT_MANAGER = "SELECT_ASSIGNMENT_MANAGER";
export const IS_REMOVING = "IS_REMOVING";
export const REMOVE_COMMITMENT = "REMOVE_COMMITMENT";
export const EMPTY_COMMITMENTS = "EMPTY_COMMITMENTS";
export const GETTING_RESULTS = "GETTING_RESULTS";
export const SET_RESULTS = "SET_RESULTS";
export const REMOVE_RESULTS = "REMOVE_RESULTS";
export const CHANGE_MODE = "CHANGE_MODE";

export function getOffices(offices) {
  return {
    type: FETCH_OFFICES,
    payload: offices
  };
}

export function gettingOffices(isGetting) {
  return {
    type: GETTING_OFFICES,
    payload: isGetting
  };
}

export function selectOffice(office) {
  return {
    type: SELECT_OFFICE,
    payload: office
  };
}

export function gettingAssignmentManagerList(isGetting) {
  return {
    type: GETTING_ASSIGNMENT_MANAGER_LIST,
    payload: isGetting
  };
}

export function setAssignmentManagerList(assignmentManagerList) {
  return {
    type: SET_ASSIGNMENT_MANAGER_LIST,
    payload: assignmentManagerList
  };
}

export function gettingCommitments(isGetting) {
  return {
    type: GETTING_COMMITMENTS,
    payload: isGetting
  };
}

export function assignmentManagerGetCommitments(commitments) {
  return {
    type: ASSIGNMENT_MANAGER_GET_COMMITMENTS,
    payload: commitments
  };
}

export function emptyCommitments() {
  return {
    type: EMPTY_COMMITMENTS
  };
}

export function gettingResults(value) {
  return {
    type: GETTING_RESULTS,
    payload: value
  };
}

export function setResults(results) {
  return {
    type: SET_RESULTS,
    payload: results
  };
}

export function removeResultStatistics() {
  return {
    type: REMOVE_RESULTS
  };
}
